import DOMPurify from 'dompurify';
import styles from './HoverPreviewOverlay.module.css';

/**
 * HTML body for the cell hover preview (sanitized). Rendered inside PopoverContent.
 * @param {object} props
 * @param {CellHoverContent} props.html - HTML string to render (trusted backend content)
 * @param {boolean} [props.isEmpty] - Show empty-state message
 * @param {Error | null} [props.error] - Error to display
 * @returns {JSX.Element}
 */
function HoverPreviewOverlay({
  html,
  isEmpty = false,
  error = null,
}) {
  const cleanHtml = html ? DOMPurify.sanitize(html, { USE_PROFILES: { html: true } }) : '';

  return (
    <div
      className={styles.panel}
      role="presentation"
    >
      {error && (
        <div className={styles.error}>{error.message}</div>
      )}
      {!error && isEmpty && (
        <div className={styles.empty}>Aucune information à afficher</div>
      )}
      {!error && !isEmpty && cleanHtml && (
        <div
          className={styles['panel-content']}
          // eslint-disable-next-line react/no-danger
          dangerouslySetInnerHTML={{ __html: cleanHtml }}
        />
      )}
    </div>
  );
}

export default HoverPreviewOverlay;
